export default __webpack_public_path__ + "static/media/vc.d4b6a3da.svg";